import React from "react";
import SectionTitle from "../../components/SectionTitle";
import { useSelector } from "react-redux";

const SayHello = () => {
  const { portfolioData } = useSelector((state) => state.root);
  const { detail } = portfolioData; // Initialize to an empty array if undefined

  return (
    <div>
      <SectionTitle title="Say Hello" />
      <div className="flex flex-row bg-primary dark:bg-bg-dark px-52 py-10 sm:flex-col sm:px-3 sm:py-3">
        <iframe
          title="contact_img"
          src="https://lottie.host/embed/e1c8118e-3c4e-4e9f-866e-416d79288f18/kpi96x5ODe.json"></iframe>
        <div className="text-tertiary px-48 pt-10 pb-20 sm:px-3 sm:pb-6 sm:text-sm">
          {detail && (
            <pre>{JSON.stringify({ ...detail, _id: undefined }, null, 2)}</pre>
          )}
        </div>
      </div>
    </div>
  );
};

export default SayHello;
